var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',_vm._g({class:_vm.iconClass,style:(_vm.iconStyle),attrs:{"aria-hidden":"true"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }